export default () => jQuery(($) => {
	$('.issueMenu input[type="submit"]').hide();
	$('.issueMenu select[name="issue"]').change(function () {
		$(this).parent('form').submit();
	});
});
